
<div class="pa-0" v-if="liftmanager">
    <d-inbox-detail
        v-model     = "details.show"
        :attachment = "details.message"
        :height     = "fullheight"
        @morph      = "onMorph"
        @context    = "onContext"
    />

    <c-drawer-header
        v-resize   = "onResize"
        title      = "Inbox"
        :subtitle  = "customer ? customer.name : null"
        icon       = "fas fa-inbox"
        :usefilter = "true"
        :usetoggle = true
        @close     = "onClose"
        @filter    = "onFilter"
        @toggle    = "onToggle"
        @arrow     = "onArrow"
    >
        <template v-slot:toolbar>
            <div class="v-flex pr-1" style="margin-top: -2px">
                <c-toolbar-button
                    icon="mdi-reload"
                    tooltip="Meldungen erneut laden"
                    color="white"
                    size="20"
                    @click ="onReload"
                />
            </div>
        </template>
    </c-drawer-header>
    <v-expand-transition>
        <div v-if="filter" class="filter-panel">
            <v-row dense>
                <v-col class="pr-2">
                    <div>
                        <c-customer-select
                            v-model       = "customer"
                            label         = "Kunde"
                            :my-customers = "true"
                            :hide-details = "true"
                        />
                    </div>
                </v-col>
                <v-col class="pl-2">
                    <f-enum-select
                        v-model   = "messagetype"
                        label     = "Meldungsart"
                        module    = "inb"
                        type      = "messageTypes"
                        clearable
                        hide-details
                    />
                </v-col>
            </v-row>

            <div class="mt-3 mb-3">
                <v-text-field
                    v-model        = "searchtext"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    label          = "Volltextsuche"
                    clearable
                    hide-details
                />
            </div>
        </div>
    </v-expand-transition>

    <div v-if="loading">
        <v-progress-linear
            color  = "primary"
            height = "4"
            indeterminate
        />
    </div>

    <v-row dense>
        <v-col class="inb-messages-col">
            <v-layout row wrap  class="inb-messages-list" :style="'height: ' + height + 'px'">
                <drop
                    class="cut"
                    @drop        = "onDrop"
                    :accepts-type="onAcceptType"
                    mode         = "cut"
                >
                    <div v-if="messages.length === 0" class="inb-no-messages">
                        Keine Meldungen vorhanden
                    </div>
                    <v-container v-if="messages.length > 0" fluid class="w-100 pa-0">
                    <v-data-iterator
                        :items         = "messages"
                        :search        = "searchtext"
                        :custom-filter = "cfilter"
                        hide-default-footer
                        :items-per-page="100"
                        :key = "refresh"
                    >
                        <template v-slot:default="props">
                            <drag
                                v-for="(item,index) in props.items"
                                class      = "item"
                                @cut       = "onRemove(item)"
                                @dragend   = "onDragend"
                                :key       = "item.id"
                                :type      =  "dragData (item)"
                                :disabled  = "item.incidentId!==null"
                                :data      = "dragData(item)"
                            >
                                <inb-message-entry
                                    :message = "item"
                                    :context = "context"
                                    v-model  = "menuOpen"
                                    @edit    = "onEdit"
                                    :class   = "index < props.items.length-1 ? 'mb-4' : ''"
                                />
                            </drag>
                        </template>
                    </v-data-iterator>
                </v-container>
                </drop>
            </v-layout>
        </v-col>
    </v-row>
</div>
